import { render, staticRenderFns } from "./FCCRunPenalities.vue?vue&type=template&id=4740384f"
import script from "./FCCRunPenalities.vue?vue&type=script&lang=js"
export * from "./FCCRunPenalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports